import { type FCIError, FCI_ERROR, FCI_HEADER, FCI_IDENTITY } from "@searchui-searchforms/shared/fci";
import { type EnhancedFetchOptions, enhancedFetch } from "@/shared/utils/enhancedFetch";
import { logFCI } from "./logFCI";

interface FCIFetchOptions extends EnhancedFetchOptions {
    fci: { errorType: FCIError; errorInfo: string };
}

export async function fciFetch<T = any>(resource: RequestInfo | URL, options: FCIFetchOptions): Promise<T> {
    const { fci, headers, ...rest } = options;

    try {
        return await enhancedFetch<T>(resource, {
            ...rest,
            headers: {
                ...Object.fromEntries(new Headers(headers).entries()),
                [FCI_HEADER.ErrorType]: fci.errorType,
                [FCI_HEADER.ErrorInfo]: fci.errorInfo,
                [FCI_HEADER.Feature]: FCI_IDENTITY.Feature,
            },
        });
    } catch (error) {
        if (error instanceof Error && error.name === "TimeoutError") {
            logFCI({
                errorType: FCI_ERROR.Timeout,
                errorInfo: `${fci.errorInfo}: ${error.message}`,
                details: {
                    stack: error.stack,
                },
            });
        }
        throw error;
    }
}
